import React from "react";

import MaterialIcon from "@material/react-material-icon";
import { Link } from "react-scroll";
import PropTypes from "prop-types";

export default class ScrollDown extends React.Component {
  static propTypes = {
    anchor: PropTypes.string.isRequired
  };

  render() {
    const { anchor } = this.props;

    return (
      <Link to={anchor} className="scroll-down" smooth>
        <MaterialIcon icon="keyboard_arrow_down" />
      </Link>
    );
  }
}
